import { db } from "../../firebaseConfig";
import {
  collection,
  addDoc,
  setDoc,
  doc,
  getDocs,
  writeBatch,
} from "firebase/firestore";
import { auth } from "../../firebaseConfig";
import { get } from "react-hook-form";
import { currentUser } from "../../SignIn/SignIn";

const arrayToIndexedObject = (arr = []) => {
  const out = {};
  (Array.isArray(arr) ? arr : []).forEach((item, i) => {
    out[i] = item;
  });
  return out;
};

const writeDataS1 = async (formData) => {
  // console.log("Form data: ", formData);
  const user = auth.currentUser;
  // console.log(user.uid);

  if (!user || !user.uid) {
    throw new Error("User is not authenticated or user ID is missing.");
  }

  try {
    // 1) Personal Details
    const personalRef = doc(db, "Advisers", user.uid, "Personal Details", "Data");
    await setDoc(
      personalRef,
      {
        ...formData.personalDetails,
        recruitmentUpdates: [
          {
            date: new Date(),
            update: "Pending",
            description: "Not yet submitted",
          },
        ],
      },
      { merge: true },
    );

    // 2) Application Details
    const applicationRef = doc(
      db,
      "Advisers",
      user.uid,
      "Application Details",
      "Data",
    );
    await setDoc(
      applicationRef,
      { ...formData.applicationDetails },
      { merge: true },
    );

    // 3) Previous Addresses (store as numeric keys: 0,1,2...)
    const prevAddressRef = doc(
      db,
      "Advisers",
      user.uid,
      "Application Details",
      "Previous Addresses",
    );

    await setDoc(
      prevAddressRef,
      arrayToIndexedObject(formData.previousAddress || []),
      {
        merge: true,
      },
    );

    // 4) Next of Kin
    const nokRef = doc(
      db,
      "Advisers",
      user.uid,
      "Application Details",
      "Next of Kin Details",
    );

    await setDoc(nokRef, { ...formData.nextOfKinDetails }, { merge: true });
  } catch (error) {
    // console.error("Error writing Section 1:", error);
  }
};

export default writeDataS1;